module.exports = __webpack_public_path__ + "static/media/asui-tsuyu-lose.9e9026a4.png";